"use client"

import ClientLink, {
  ClientLinkProps,
} from "@modules/common/components/client-link"
import { useCallback } from "react"

interface ScrollLinkProps extends Omit<ClientLinkProps, "onClick"> {
  children: React.ReactNode
}

export const ScrollLink = ({ href, children, ...props }: ScrollLinkProps) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (typeof href === "string" && href.includes("#")) {
        const hash = href.substring(href.indexOf("#"))
        const id = hash.replace("#", "")

        // Prevent default only if we're scrolling to an element on the same page
        if (
          window.location.hash === hash ||
          window.location.pathname === href.split("#")[0]
        ) {
          e.preventDefault()
          const element = document.getElementById(id)
          if (element) {
            setTimeout(() => {
              const elementPosition = element.getBoundingClientRect().top
              const offsetPosition = elementPosition + window.scrollY - 64

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              })
              // Update the URL without navigation
              window.history.replaceState(null, "", hash)
            }, 0)
          }
        }
      }
    },
    [href]
  )

  return (
    <ClientLink href={href} {...props} onClick={handleClick as any}>
      {children}
    </ClientLink>
  )
}
